<!-- the z-index is used to ensure the bar is placed above the expression overlay -->
<nav class="bg-surface-0 relative z-50 grid grid-cols-3 items-center p-2 shadow-md select-none">
  <h1 class="font-heading text-surface-700 text-md font-bold">{{ name() }}</h1>
  @if (steps() > 0) {
    <rid-progress-bar class="h-4" [steps]="steps()" [progress]="progress()" />
  }
</nav>
